export function formatAmount(amount: number, currency: string) {
    return `${(+amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${currency}`;
}

